import { cn } from '@anytag/shared-utils';
import { Anchor, AnchorProps } from '../../Anchor';

export const Link = ({ className, children, ...restProps }: AnchorProps) => (
  <Anchor className={cn('inline-block min-w-50 text-base leading-4', className)} {...restProps}>
    {children}
  </Anchor>
);
